module.exports = __webpack_public_path__ + "static/media/404.5fb1b5c2.svg";